module.exports = __webpack_public_path__ + "static/media/tc.b4bb9eb9.svg";